import VueRouter, { RouteConfig } from 'vue-router'

const ClazzJoin = () => import('../views/ClazzJoin.vue')

export const clazzJoinRoute: RouteConfig = {
  path: '/clazz-join',
  name: 'clazz_join',
  component: ClazzJoin,
}

export default [clazzJoinRoute]

export function navigateToClazzJoin(router: VueRouter) {
  return router.push({ name: clazzJoinRoute.name })
}
